import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { V2L2WorkItemDetailActions, V2L2WorkItemDetailContent, V2L2WorkItemDetailRoot, V2L2WorkItemDetailTitle } from "./V2L2WorkItemDetail"
import { V2L2WorkItemDetailContentItem } from "./V2L2WorkItemDetailContentItem"
import { faArrowsRotate, faBan } from '@fortawesome/pro-regular-svg-icons'
import { L1ReasonableButton } from '../../../form/l1/L1Button'

interface V2L3WorkItemVoidedDetailProps {
	title: string
	onRefreshClick: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L3WorkItemVoidedDetail = ({title, onRefreshClick}: V2L3WorkItemVoidedDetailProps) => {
	return (
		<V2L2WorkItemDetailRoot>
			<V2L2WorkItemDetailTitle ready={false}>
				<FontAwesomeIcon icon={faBan} />
				{title}
			</V2L2WorkItemDetailTitle>
			<V2L2WorkItemDetailContent>
				<V2L2WorkItemDetailContentItem label="Notice" span={3}>
					This appointment has been voided.  Please click below to perform a full refresh of your appointments from the cloud, or contact support for assistance.
				</V2L2WorkItemDetailContentItem>
			</V2L2WorkItemDetailContent>
			<V2L2WorkItemDetailActions>
				<L1ReasonableButton
					icon={faArrowsRotate}
					label="Refresh"
					onClick={onRefreshClick}
				/>
			</V2L2WorkItemDetailActions>
		</V2L2WorkItemDetailRoot>
	)
}
